import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../../../PageHeader';
import CorporateSectionLayout from '../../../CorporateSectionLayout';
import SistemManajemen from './SistemManajemen';

function SistemManajemenLayout() {
    const items = [{ id: 'sistem-manajemen', number: '01', label: 'Sistem Manajemen', content: <SistemManajemen /> }];
    return <>
        <Helmet><title>Sistem Manajemen | PT Len Telekomunikasi Indonesia</title><meta name="description" content="Sistem Manajemen PT Len Telekomunikasi Indonesia." /><link rel="canonical" href="https://www.len-telko.co.id/tata-kelola-perusahaan/sistem-manajemen" /></Helmet>
        <PageHeader title="Sistem Manajemen" />
        <CorporateSectionLayout title="Sistem Manajemen" eyebrow="Tata Kelola Perusahaan" items={items} />
    </>;
}
export default SistemManajemenLayout;
